import {
  SR_API_ERROR,
  SR_PURCHASE_INDENTS_LIST,
  SR_PURCHASE_INDENTS_LIST_SUCCESS,
  SR_PURCHASE_INDENTS_LIST_CHECKED,
  ALL_SR_PURCHASE_INDENTS_LIST_CHECKED,
  SR_RFQ_SELECTED_SR_ITEM,
  SR_RFQ_SELECTED_ALL_VENDORS,
  SR_RFQ_SELECTED_VENDORS,
  SR_CELAR_VENDORS,
  SR_VENDORS_LIST,
  SR_VENDORS_LIST_SUCCESS,
  GET_SR_VENDORS_DATA,
  SR_VENDORS_DATA_SUCCESS,
  SR_RFQ_LIST,
  SR_RFQ_LIST_SUCCESS,
  SR_RFQ_LIST_COUNT,
  SR_RFQ_LIST_COUNT_SUCCESS,
  SET_PARAMS,
  FILTER_INPUT_SR_CHANGEVALUE,
  FILTER_SELECT_SR_CHANGEVALUE,
  INPUT_SR_CHANGEVALUE,
  SELECT_SR_CHANGEVALUE,
  RFQ_SR_ROW_DATA,
  RFQ_SR_ROW_DATA_SUCCESS,
  SR_REQUESTFORQUOTATION_ADD,
  SR_DOWNLOAD_RFQ_BUTTON,
  RF_SR_MODEL_LIST_OPEN,
  RF_SR_MODEL_LIST_CLOSE,
  SR_LIST_LAYOUT,
  TOGGLE_SR_ITEM_MENU,
  GENERATE_RFQ_PDF,
  FILTERS_SHOW_SR_RIGHT_SIDEBAR,
  FILTERS_HIDE_SR_RIGHT_SIDEBAR,
  CLEAR_SR_FILTER,
  ADD_SR_VENDORS,
  TOOLTI_OPEN,
  SR_PI_DETAILS_MODEL_OPEN,
  SR_PI_DETAILS_MODEL_CLOSE,
  PI_SR_ROW_DATA_SUCCESS,
  SR_CODE_DETAILS,
  SR_CODE_DETAILS_SUCCESS,
  ADD_SR_VENDORS_MODEL_CLOSE,
  ADD_SR_VENDORS_MODEL_OPEN,
  MR_SR_ITEM_IMAGES,
  MR_SR_ITEM_IMAGES_SUCCESS,
  PI_MR_SR_ITEM_IMAGES_MODEL_CLOSE,
  RFQ_PI_SR_ITEM_CANCEL,
} from "./actionTypes";
export const getPurchaseIndentItems = (data) => {
  return {
    type: SR_PURCHASE_INDENTS_LIST,
    payload: { data },
  };
};
export const getPuchaseIndentItemsSuccessful = (response) => {
  return {
    type: SR_PURCHASE_INDENTS_LIST_SUCCESS,
    payload: response,
  };
};
export const PuchaseIndentItemsChecked = (checked, item, index) => {
  return {
    type: SR_PURCHASE_INDENTS_LIST_CHECKED,
    payload: { checked, item, index },
  };
};
export const AllPuchaseIndentItemsChecked = (checked) => {
  return {
    type: ALL_SR_PURCHASE_INDENTS_LIST_CHECKED,
    payload: { checked },
  };
};
export const RFQSelectedItems = (checked, item) => {
  return {
    type: SR_RFQ_SELECTED_SR_ITEM,
    payload: { checked, item },
  };
};
export const RFQSelectedAllVendors = (checked) => {
  return {
    type: SR_RFQ_SELECTED_ALL_VENDORS,
    payload: { checked },
  };
};
export const RFQSelectedVendors = (checked, vend, index) => {
  return {
    type: SR_RFQ_SELECTED_VENDORS,
    payload: { checked, vend, index },
  };
};
export const ClearVendors = () => {
  return {
    type: SR_CELAR_VENDORS,
  };
};
export const getRFQRequestList = (data) => {
  return {
    type: SR_RFQ_LIST,
    payload: { data },
  };
};
export const RFQRequestListSuccessful = (response) => {
  return {
    type: SR_RFQ_LIST_SUCCESS,
    payload: response,
  };
};
export const getRFQListcount = (data) => {
  return {
    type: SR_RFQ_LIST_COUNT,
    payload: { data },
  };
};
export const RFQListCountSuccessful = (request) => {
  return {
    type: SR_RFQ_LIST_COUNT_SUCCESS,
    payload: request,
  };
};
export const addVendorsModelOpen = (RFQId) => {
  return {
    type: ADD_SR_VENDORS_MODEL_OPEN,
    payload: { RFQId },
  };
};
export const addVendorsModel_close = () => {
  return {
    type: ADD_SR_VENDORS_MODEL_CLOSE,
  };
};
export const getVendorsList = (data, addVendors, clearVendlist = false) => {
  return {
    type: SR_VENDORS_LIST,
    payload: { data, addVendors, clearVendlist },
  };
};
export const VendorsListSuccessful = (response) => {
  return {
    type: SR_VENDORS_LIST_SUCCESS,
    payload: response,
  };
};
export const getVendorData = (VendId) => {
  return {
    type: GET_SR_VENDORS_DATA,
    payload: { VendId },
  };
};
export const VendorDataSuccessful = (response) => {
  return {
    type: SR_VENDORS_DATA_SUCCESS,
    payload: response,
  };
};
export const addRFQRequest = (data) => {
  return {
    type: SR_REQUESTFORQUOTATION_ADD,
    payload: { data },
  };
};
export const downloadRFQButton = (RFQId) => {
  return {
    type: SR_DOWNLOAD_RFQ_BUTTON,
    payload: { RFQId },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_SR_ITEM_MENU,
    payload: id,
  };
};
export const SelecteSR_ChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_SR_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const InputSR_ChangeValue = ({ key, value }) => {
  return {
    type: INPUT_SR_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const FilterSR_ChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_SR_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteSR_ChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_SR_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const getRFQRequestdata = (rfqId) => {
  return {
    type: RFQ_SR_ROW_DATA,
    payload: { rfqId },
  };
};
export const getRFQRequestdataSuccessful = (request) => {
  return {
    type: RFQ_SR_ROW_DATA_SUCCESS,
    payload: request,
  };
};
export const rf_model_list_open = (rfqId) => {
  return {
    type: RF_SR_MODEL_LIST_OPEN,
    payload: { rfqId },
  };
};

export const rf_model_list_close = () => {
  return {
    type: RF_SR_MODEL_LIST_CLOSE,
  };
};

export const listlayout = (layout) => {
  return {
    type: SR_LIST_LAYOUT,
    payload: layout,
  };
};
export const generateRFQasPDF = (RFQId) => {
  return {
    type: GENERATE_RFQ_PDF,
    payload: { RFQId },
  };
};
export const FiltersShowRightSidebar = () => {
  return {
    type: FILTERS_SHOW_SR_RIGHT_SIDEBAR,
    payload: null,
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_SR_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_SR_FILTER,
    payload: null,
  };
};
export const addVendors = (data, rfqId) => {
  return {
    type: ADD_SR_VENDORS,
    payload: { data, rfqId },
  };
};

export const tooltipOpen = (Item) => {
  return {
    type: TOOLTI_OPEN,
    payload: { Item },
  };
};
export const PIDetailsModel_open = (PIID) => {
  return {
    type: SR_PI_DETAILS_MODEL_OPEN,
    payload: { PIID },
  };
};

export const PIDetailsModel_close = () => {
  return {
    type: SR_PI_DETAILS_MODEL_CLOSE,
  };
};

export const PIRowDataSuccessful = (response) => {
  return {
    type: PI_SR_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const getMRCodeDetails = (ItemId) => {
  return {
    type: SR_CODE_DETAILS,
    payload: { ItemId },
  };
};
export const getMRCodeDetailsSuccessful = (response) => {
  return {
    type: SR_CODE_DETAILS_SUCCESS,
    payload: response,
  };
};
export const getMRItemImges = (PIItemId) => {
  return {
    type: MR_SR_ITEM_IMAGES,
    payload: { PIItemId },
  };
};
export const getMRItemImgesSuccessful = (response) => {
  return {
    type: MR_SR_ITEM_IMAGES_SUCCESS,
    payload: response,
  };
};
export const PIMRItemImagesModel_close = () => {
  return {
    type: PI_MR_SR_ITEM_IMAGES_MODEL_CLOSE,
    payload: null,
  };
};
export const PIitemCancel = (data) => {
  return {
    type: RFQ_PI_SR_ITEM_CANCEL,
    payload: { data },
  };
};
export const apiError = (error) => {
  return {
    type: SR_API_ERROR,
    payload: error,
  };
};
